import { defineMessages } from 'react-intl'

export default defineMessages({
    orderNumber: {
        id: 'containers.Accounting.AccountingDraftOrdersPage.components.ReportHeader.orderNumber',
        defaultMessage: 'Order No.',
    },
    orderNumberPlaceholder: {
        id: 'containers.Accounting.AccountingDraftOrdersPage.components.ReportHeader.orderNumberPlaceholder',
        defaultMessage: 'Order number',
    },
    customerNumber: {
        id: 'containers.Accounting.AccountingDraftOrdersPage.components.ReportHeader.customerNumber',
        defaultMessage: 'Customer No.',
    },
    customerNumberPlaceholder: {
        id: 'containers.Accounting.AccountingDraftOrdersPage.components.ReportHeader.customerNumberPlaceholder',
        defaultMessage: 'Customer number',
    },
    search: {
        id: 'containers.Accounting.AccountingDraftOrdersPage.components.ReportHeader.search',
        defaultMessage: 'Search',
    },
    dateFrom: {
        id: 'containers.Accounting.AccountingDraftOrdersPage.components.ReportHeader.dateFrom',
        defaultMessage: 'Date from',
    },
    dateTo: {
        id: 'containers.Accounting.AccountingDraftOrdersPage.components.ReportHeader.dateTo',
        defaultMessage: 'Date To',
    }
})
